import { styled } from '@mui/material';
import { ReactComponent as IconAzure } from '../../../assets/images/azure.svg';

export const StyledIconAzure = styled(IconAzure)(() => ({
  height: '46px',
  width: '46px',
}));
